import { Injectable, inject } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import { ConnectorApi, ConnectorInfo } from '@adesso/dataspace-api-client';
import { ADESSO_API_CONFIG } from '../../../../core/api/adesso-api.config';
import { ConnectorData } from '../models/connector-data.model';
import { ConnectorApiPort } from '../ports/connector-api.port';

@Injectable()
export class AdessoConnectorApiAdapter extends ConnectorApiPort {
  private readonly api = new ConnectorApi(inject(ADESSO_API_CONFIG));

  getConnectorData(): Observable<ConnectorData> {
    return from(this.api.getConnectorInfo()).pipe(map((res) => toDomain(res.data)));
  }
}

function toDomain(dto: ConnectorInfo): ConnectorData {
  return {
    participantId: dto.participantId ?? '',
    connectorRuntimeId: dto.connectorId ?? '',
    edcVersion: dto.edcVersion ?? '',
    tractusxVersion: dto.tractusxVersion ?? '',
    connectorHTTPEndpoint: dto.httpEndpoint ?? '',
    connectorManagementEndpoint: dto.managementEndpoint ?? '',
    connectorDSPProtocolEndpoint: dto.protocolEndpoint ?? '',
    persistenceType: dto.persistenceType ?? '',
    vaultType: dto.vaultType ?? '',
    didUrl: dto.didUrl ?? null,
    stsTokenUrl: dto.stsTokenUrl ?? null,
    connectorType: dto.connectorType ?? ''
  };
}
